import { render } from "./About.vue?vue&type=template&id=f8ba3b30&scoped=true"
const script = {}

import "./About.vue?vue&type=style&index=0&id=f8ba3b30&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f8ba3b30"]])

export default __exports__